<div class="alert-overlay alert-dialog">
	<div class="alert-container" (click)="$event.stopPropagation()">
		<div class="confirmBtn" (click)="confirm()">

		</div>
	</div>
</div>